<div class='page-container' id='page-container' fxLayout='column' id='content'>
  <div class='assessment-container ' *ngIf='pageReady && !loadingUserAssessmentError; else loader'>
    <button mat-stroked-button routerLink="/assessments">
      <mat-icon>keyboard_arrow_left</mat-icon>Back to Assesment</button>

    <div class='assessment-details assessment-font' fxLayout='column' fxLayoutAlign='center center'>
      <div fxLayout='row'>
        <span class='header'>Name: </span>
        <span class='value'>{{userAssessment.name}}</span>
      </div>
      <div fxLayout='row'>
        <span class='header'>Date Started: </span>
        <span class='value'>{{userAssessment.created_at | date : 'medium'}}</span>
      </div>
      <div fxLayout='row'>
        <span class='header'>Date Completed: </span>
        <span class='value'>{{userAssessment.updated_at  | date : 'medium'}}</span>
      </div>
      <div fxLayout='row' *ngIf='!!userAssessment.grade' class='tally-grade'>
        <span class='header'>Grade: </span>
        <span class='value'>{{userAssessment.grade || 'Not Graded'}}</span>
      </div>
    </div>
    <div class='print-action' fxLayout='row' fxLayoutAlign='end center'>
      <button mat-button color='primary' printSectionId='demo' (click)='saveAsPDF()'><mat-icon>picture_as_pdf</mat-icon>Save As PDF</button>
    </div>
    <div *ngFor='let question of userAssessment.questions; let i = index'>
      <div class="question-container">
        <div class="question-container-heading default-padding" fxLayout="row" fxLayoutAlign="start center">
          <h3 class="bolder no-margin" >
            Question {{ i + 1 }} of {{ userAssessment.questions.length }}
          </h3>
        </div>
        <div class="current-question-container">
          <h3 class="question-label default-padding">
            {{ question.question }}
          </h3>
          <div class='question-choice'>
            <div *ngIf="question.has_options && question.is_multi_answer">
                <!-- here we need to the select all that applied -->
                <h4>Select all that apply</h4>
                <mat-select class="gtap-option" [value]='question.user_answer'>
                  <mat-option   *ngFor="let option of question.options" [value]="option.value.value">{{ option.friendly }}</mat-option>
                </mat-select>
              </div>

              <!-- has option and single answer we need to used the radio -->
              <div *ngIf="question.has_options && !question.is_multi_answer" class="bolder">
                <mat-radio-group fxLayout="column" fxLayoutGap="10px" [value]='question.user_answer' [disabled]='true'>
                  <mat-radio-button class="gtap-option" *ngFor="let option of question.options"
                    [value]="option.value.value" fxFlex>{{ option.friendly }}</mat-radio-button>
                </mat-radio-group>
              </div>

              <!-- Free answer -->
              <div *ngIf="!question.has_options && !question.is_multi_answer">
                <h2>{{question.user_answer}}</h2>
              </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loader>
    <div fxLayout='column' fxLayoutAlign='center center' fxFlex>
      <div *ngIf='!loadingUserAssessmentError; else notFound'>
        <mat-spinner></mat-spinner>
        <h3>Getting assessment results</h3>
      </div>

      <ng-template #notFound>
        <h3>Assessment Result not found</h3>

      </ng-template>
    </div>
  </ng-template>
</div>
